"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divider = exports.FooterCopyright = exports.FooterContent = exports.Footer = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _slice = require("@lce/slice");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Footer = (0, _styledComponents["default"])(_slice.Box).attrs({
  as: 'footer'
})(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  width: 100%;\n  max-width: 1500px;\n  margin: 0 auto;\n"], ["\n  width: 100%;\n  max-width: 1500px;\n  margin: 0 auto;\n"])));
exports.Footer = Footer;
var FooterContent = (0, _styledComponents["default"])(_slice.Box)(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  max-width: 800px;\n  margin: 0 auto;\n  font-size: 14px;\n  text-align: center;\n"], ["\n  max-width: 800px;\n  margin: 0 auto;\n  font-size: 14px;\n  text-align: center;\n"])));
exports.FooterContent = FooterContent;
var FooterCopyright = (0, _styledComponents["default"])(_slice.Box)(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  max-width: 600px;\n  margin: 0 auto;\n  font-size: 14px;\n  text-align: center;\n"], ["\n  max-width: 600px;\n  margin: 0 auto;\n  font-size: 14px;\n  text-align: center;\n"])));
exports.FooterCopyright = FooterCopyright;
var Divider = (0, _styledComponents["default"])(_slice.Box)(templateObject_4 || (templateObject_4 = (0, _tslib.__makeTemplateObject)(["\n  height: 1px;\n  background-color: ", ";\n  width: 100%;\n  margin: 20px 0;\n"], ["\n  height: 1px;\n  background-color: ", ";\n  width: 100%;\n  margin: 20px 0;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
});
exports.Divider = Divider;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;